


































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PublicVibrixEvent } from "@/interfaces/vibrixEvent";
import { EventService } from "@/services/eventService";
import EventDetailCard from "@/components/EventDetailCard.vue";
import EventPublicCalendar from "@/components/EventPublicCalendar.vue";

@Component({ components: { EventDetailCard, EventPublicCalendar } })
export default class EventRegistration extends Vue {
    @Prop() public eventId!: string;
    @Prop() public email?: string;
    @Prop() public source?: string;

    valid: boolean = false;

    public loading: boolean = false;
    public event: PublicVibrixEvent | null = null;

    @Watch("eventId", { immediate: true })
    public async loadEvent(eventId: string) {
        if (!eventId) {
            this.$store.commit("showSnackbar", {
                color: "error",
                text: this.$t("event.malformedLink"),
            });
            return;
        }
        this.loading = true;
        try {
            this.event = await EventService.getEventByIdPublic(eventId);
        } finally {
            this.loading = false;
        }
    }
    public get signupData(): {
        key: { id: string; value: string | boolean };
        label: string;
        rule: string[];
        type: string;
    }[] {
        return [
            {
                key: { id: "email", value: this.email ?? "" },
                label: "event.signup.email",
                rule: ["required", "email"],
                type: "textbox",
            },
            ...(!this.email
                ? [
                      {
                          key: { id: "name", value: "" },
                          label: "event.signup.name",
                          rule: ["required"],
                          type: "textbox",
                      },
                      {
                          key: { id: "lastname", value: "" },
                          label: "event.signup.lastname",
                          rule: ["required"],
                          type: "textbox",
                      },
                      {
                          key: { id: "zip", value: "" },
                          label: "event.signup.zip",
                          rule: ["required"],
                          type: "textbox",
                      },
                      {
                          key: { id: "company", value: "" },
                          label: "event.signup.company",
                          rule: ["required"],
                          type: "textbox",
                      },
                      {
                          key: { id: "phone", value: "" },
                          label: "event.signup.phone",
                          rule: ["required"],
                          type: "textbox",
                      },
                  ]
                : []),
        ];
    }

    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || (this.$t("studio.required") as string),
            length: v =>
                v.length < 255 || (this.$t("guest.username.invalid") as string),
            email: v =>
                /^$|^[\w.-]+@[\w.-]+$/gi.test(v) ||
                (this.$t("guest.email.invalid") as string),
        };
    }
    public async submitRegistration() {
        this.loading = true;
        try {
            const result: {
                [key: string]: string | boolean;
            } = {};
            this.signupData.forEach(e => (result[e.key.id] = e.key.value));
            result.source = this.source || "";
            await EventService.createRegistration({
                // eslint-disable-next-line @typescript-eslint/camelcase
                event_id: this.eventId,
                signupMeta: result,
            })
                .then(r => {
                    this.$store.commit("showSnackbar", {
                        text: this.$t("event.submittedRegistration"),
                        color: "success",
                    });
                    this.$router.replace(
                        `/events/registration/complete/${r.id}`
                    );
                })
                .catch(e => {
                    console.log("catch in registration", e.message);
                    this.$store.commit("showSnackbar", {
                        text: this.$t(e.message),
                        color: "error",
                    });
                    return;
                });
        } finally {
            this.loading = false;
        }
    }

    public reloadWithoutEmail() {
        this.$router.push(
            `/events/registration?eventId=${this.eventId}&email=`
        );
    }
}
